import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const customerServiceOrganizationsRoute: InvariantJiraRoute = {
	name: 'customer-service-organizations',
	path: '/jira/customer-service/organizations',
	exact: true,
};
